import { ContentItem, Elements } from '@kentico/kontent-delivery'

/**
 * Generated by '@kentico/kontent-model-generator@3.2.0'
 * Tip: You can replace 'ContentItem' with another generated class to fully leverage strong typing.
 */
export class PersonalInformationProcessing extends ContentItem {
  public personalInfoProcessingText: Elements.RichTextElement
  public personalInfoProcessingPicture: Elements.AssetsElement
  public tabs: Elements.RichTextElement
  public partners: Elements.LinkedItemsElement<ContentItem>
  public objectType: Elements.TaxonomyElement
  public pageParentUrl: Elements.TextElement
  public pageParentName: Elements.TextElement
  constructor() {
    super({
      propertyResolver: (elementName: string) => {
        if (elementName === 'personal_info_processing_text') {
          return 'personalInfoProcessingText'
        }
        if (elementName === 'personal_info_processing_picture') {
          return 'personalInfoProcessingPicture'
        }
        if (elementName === 'object_type') {
          return 'objectType'
        }
        if (elementName === 'page_parent__url') {
          return 'pageParentUrl'
        }
        if (elementName === 'page_parent__name') {
          return 'pageParentName'
        }
        return elementName
      },
    })
  }
}
